import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './NewsCarousel.css';
import React, { useEffect, useState, useContext, useRef } from 'react';
import throttle from 'lodash/throttle';
import { canUseDOM, get } from '../../utils';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import ScrollAnimation from 'react-animate-on-scroll';
import NewsCarouselItem from './NewsCarouselItem';
import RouterLink from '../atoms/RouterLink';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../utils/tealium';
import getListing, { loadCategoryAlgoliaResults } from '../../utils/getListing';
import { convertToAnalyticObject } from '../../utils/analytics';
import { usePersonalizedList } from '@uniformdev/personalize-react';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
export var NewsCarousel = function NewsCarousel(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    route = _ref.route;
  var sitecoreContext = useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var isPersonalised = sitecoreContext.isPersonalised;
  var carouselWrapperRef = useRef(null);
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isVdsite = _useState2[0],
    setIsVdsite = _useState2[1];
  var _React$useState = React.useState(undefined),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isHidden = _React$useState2[0],
    setIsHidden = _React$useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    titleHeight = _useState4[0],
    setTitleHeight = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    descriptionHeight = _useState6[0],
    setDescriptionHeight = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    dateHeight = _useState8[0],
    setDateHeight = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    btnHeight = _useState10[0],
    setBtnHeight = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    searchResults = _useState12[0],
    setSearchResults = _useState12[1];
  var variant = get(params, 'variant');
  var indexName = get(params, 'SearchIndex');
  var searchCount = Number(get(params, 'SearchCount'));
  var allValues = [];
  var title = get(fields, 'data.datasource.title.jss');
  var tags = get(fields, 'data.datasource.tags.values');
  var ctaLink = get(fields, 'data.datasource.ctaLink.jss.value.href');
  var ctaLabel = get(fields, 'data.datasource.ctaLabel.jss.value');
  var intents = get(fields, 'data.datasource.intents');
  var intentsLength = get(intents, 'targetItems.length');
  var contextItem = get(fields, 'data.contextItem');
  var currentPageID = get(route, 'itemId', '').split('-').join('');
  var dummyId;
  if (process.env.STORYBOOK_MODE) {
    dummyId = '6a1d9e4935ad4273804e7cbc56f0d62b';
  }
  var _usePersonalizedList = usePersonalizedList({
      rendering: contextItem,
      route: route,
      list: searchResults,
      conditions: [algoliaScoredCondition(allValues)]
    }),
    personalizedList = _usePersonalizedList.personalizedList,
    refreshTracking = _usePersonalizedList.refreshTracking;
  useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  useEffect(function () {
    if (isPersonalised && intentsLength) {
      _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var hits;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return loadCategoryAlgoliaResults(allValues || [], 'News', searchCount, tags, [''], currentPageID ? "NOT objectID:".concat(currentPageID) : '', indexName);
            case 2:
              hits = _context.sent;
              // setResults(hits);
              setSearchResults(hits);
              refreshTracking();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    } else {
      var filters = currentPageID ? "NOT objectID:".concat(currentPageID) : '';
      var itemFilter = {
        hitsPerPage: searchCount,
        facetFilters: [['News']],
        // filters: currentPageID ? `NOT objectID:${currentPageID}` : '',
        filters: filters
      };
      var results = [];
      var hiddenResults = '';
      getListing(indexName, itemFilter).then(function (hits) {
        results.push(hits && hits.hits);
        results[0].map(function (result) {
          hiddenResults += " AND NOT objectID:".concat(result.objectID);
        });
        if (hits && hits.hits.length !== searchCount) {
          var _itemFilter = {
            hitsPerPage: searchCount - hits.hits.length,
            facetFilters: [['News']],
            filters: currentPageID ? " (NOT objectID:".concat(currentPageID, " ").concat(hiddenResults, ")") : " (NOT objectID:".concat(dummyId, " ").concat(hiddenResults, ")")
          };
          getListing(indexName, _itemFilter).then(function (hits) {
            results.push(hits && hits.hits);
            var finalResults = results[0].concat(results[1]);
            finalResults.length ? setIsHidden(false) : setIsHidden(true);
            setSearchResults(finalResults);
          });
        } else {
          results[0].length ? setIsHidden(false) : setIsHidden(true);
          results[0] && setSearchResults(results[0]);
        }
      });
    }
  }, [isPersonalised]);
  var countHeights;
  if (canUseDOM) {
    countHeights = throttle(function () {
      if (carouselWrapperRef.current) {
        var titleHeights = Array.from(carouselWrapperRef.current.querySelectorAll(".title")).map(function (item) {
          return item.offsetHeight;
        });
        var descriptionHeights = Array.from(carouselWrapperRef.current.querySelectorAll(".description")).map(function (item) {
          return item.offsetHeight;
        });
        var _dateHeight = Array.from(carouselWrapperRef.current.querySelectorAll(".date-wrapper")).map(function (item) {
          return item.offsetHeight;
        });
        var _btnHeight = Array.from(carouselWrapperRef.current.querySelectorAll(".btn-tertiary--carousel--wrapper")).map(function (item) {
          return item.offsetHeight;
        });
        setTitleHeight(Math.max.apply(Math, _toConsumableArray(titleHeights)));
        setDescriptionHeight(Math.max.apply(Math, _toConsumableArray(descriptionHeights)));
        setDateHeight(Math.max.apply(Math, _toConsumableArray(_dateHeight)));
        setBtnHeight(Math.max.apply(Math, _toConsumableArray(_btnHeight)));
      }
    }, 300);
  }
  useEffect(function () {
    if (canUseDOM) {
      setTimeout(countHeights, 500);
      window.addEventListener('resize', countHeights);
    }
    return function () {
      window.removeEventListener('resize', countHeights);
    };
  }, []);
  useEffect(function () {
    setTimeout(countHeights, 500);
  }, [sitecoreContext.selectedFontSize, searchResults]);
  if (!fields) {
    console.info('NewsCarousel component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", null, "[NewsCarousel component is empty: please provide data source]");
    }
    return null;
  }
  if (searchResults.length < 1) return null;
  var showCarousel = searchResults.length > 3;
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var renderTileItems = function renderTileItems() {
    return searchResults.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 3,
        className: variant === 'Default' || variant === 'WithImage' ? '' : "".concat(variant === 'VerticalList' ? 'col-lg-12' : 'col-lg-6', " grid-item-col"),
        key: "$article-carousel-tile-".concat(index)
      }, /*#__PURE__*/React.createElement(NewsCarouselItem, _extends({}, item, {
        variant: variant,
        showCarousel: showCarousel,
        eventsAnalytics: eventsAnalytics,
        params: params
      })));
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isHidden: true,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", null, showCarousel && variant !== 'Grid' && variant !== 'VerticalList' ? /*#__PURE__*/React.createElement("div", {
    ref: carouselWrapperRef,
    style: {
      '--titles-height': titleHeight,
      '--descriptions-height': descriptionHeight,
      '--date-heights': dateHeight,
      '--btn-heights': btnHeight
    }
  }, /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref3) {
    var renderCarousel = _ref3.renderCarousel,
      renderPreviousButton = _ref3.renderPreviousButton,
      renderNextButton = _ref3.renderNextButton,
      renderDots = _ref3.renderDots,
      state = _ref3.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "btn-group--right ".concat(rtl ? 'btn-group-rtl' : '')
    }, title && /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, /*#__PURE__*/React.createElement(Text, {
      tag: "h2",
      className: "carousel-title",
      field: title
    })), /*#__PURE__*/React.createElement("div", {
      className: "btn-group-wrapper"
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['optionsPreviousClickAnalytics'], params));
    }, true, false), renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['optionsNextClickAnalytics'], params));
    }, true, false))), renderCarousel(renderTileItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 1440
          },
          items: 3
        },
        laptop: {
          breakpoint: {
            max: 1440,
            min: 1280
          },
          items: 2
        },
        tablet_landscape: {
          breakpoint: {
            max: 1280,
            min: 767
          },
          items: 2
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 560
          },
          items: 1
        },
        mobile: {
          breakpoint: {
            max: 560,
            min: 0
          },
          items: 1
        }
      }
    }), /*#__PURE__*/React.createElement(React.Fragment, null, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['optionsBubblesClickAnalytics'], params));
    }), ctaLink && /*#__PURE__*/React.createElement(ScrollAnimation, {
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1
    }, /*#__PURE__*/React.createElement(RouterLink, {
      className: "News-carousel-button--under-dots btn btn-secondary",
      href: ctaLink,
      title: "".concat(ctaLabel),
      linktype: '',
      linksTarget: '',
      onClick: function onClick() {
        return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), [title.value]);
      }
    }, ctaLabel ? ctaLabel : 'See more'))));
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, title && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: "carousel-title",
    field: title
  })), /*#__PURE__*/React.createElement("div", {
    ref: carouselWrapperRef,
    style: {
      '--titles-height': titleHeight,
      '--descriptions-height': descriptionHeight
    },
    className: "NewsItems-row row"
  }, renderTileItems()), ctaLink && /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "News-carousel-button btn btn-secondary",
    href: ctaLink,
    title: "".concat(ctaLabel),
    linktype: '',
    linksTarget: '',
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), [title.value]);
    }
  }, ctaLabel ? ctaLabel : 'See more')))));
};
var StyledWrapper = function StyledWrapper(_ref4) {
  var children = _ref4.children,
    rtl = _ref4.rtl,
    isHidden = _ref4.isHidden,
    anchorUrlParameter = _ref4.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(React.Fragment, null, ' ', !(isHidden !== undefined && !isHidden) ? /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true,
    className: "".concat(commonStyles, "  ").concat(rtl ? rtlStyles : ltrStyles)
  }, children) : null, ' ');
};
var commonStyles = "c193gvjc";
var ltrStyles = "l1fh74el";
var rtlStyles = "r1jbstym";
export default NewsCarousel;